import RootLayout from '@/routes/root/view/RootLayout.tsx'
import useSyncUser from '@/lib/hooks/useSyncUser.ts'
import useNavigateToDefaultPath from '@/routes/root/lib/hooks/useNavigateToDefaultPath.ts'
import useProjectStageData from '@/routes/root/lib/hooks/useProjectStageData.ts'
import useUpdateStageTabHref from '@/routes/root/lib/hooks/useUpdateStageTabHref.ts'
import useRecordVisitedPath from '@/lib/hooks/useRecordVisitedPath.ts'
import { useParams } from 'react-router-dom'
import { ProjectStageParamsT } from '@/routes/projectStages/routes.tsx'
import { useQueueAutoSync } from '@/lib/helpers/bgSync/useQueueAutoSync.ts'
import { useQueueDrainInvalidator } from '@/lib/helpers/bgSync/useQueueDrainInvalidator.ts'

export default function Root() {
  const { projectStageId } = useParams() as ProjectStageParamsT
  useSyncUser()

  // if projectStageId is found, loader will be executed in projectsRoot
  useProjectStageData({ path: `Root`, disabled: !!projectStageId })
  useNavigateToDefaultPath()
  useUpdateStageTabHref()
  useRecordVisitedPath()
  useQueueAutoSync()
  // Bridges the gap between the native sync queue and React Query: when a
  // queued PATCH/POST actually drains to the server, invalidate the matching
  // cached lists. The Mercure subscriber already does this PER-EVENT for the
  // Issues page — but only while that page is mounted. If the user navigates
  // to Kolejka mid-drain, those events are dropped, and on return the issues
  // list would show pre-sync optimistic state with no trigger to reconcile.
  useQueueDrainInvalidator()

  return <RootLayout />
}
